import React, { lazy, Fragment, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from 'layouts/index';
import FallBack from 'layouts/FallBack';
import { useAuth } from 'hooks/useAuth';

import LoginPage from '../pages/login';
import UnAuthorized from 'layouts/Unauthorized';

export const portalRoutes = [
	{
		path: 'dashboard',
		name: 'dashboard',
		Component: lazy(() => import('pages/Dashboard')),
		// Component: lazyImport('pages/Dashboard'),

		fallback: <FallBack />
	},
	{
		path: 'reports',
		name: 'reports',
		Component: lazy(() => import('pages/reports')),

		// Component: lazyImport('pages/Dashboard'),

		fallback: <FallBack />,

	},
	{
		path: 'reports/:reportName',
		name: 'Report Details',
		Component: lazy(() => import('pages/reports/ReportDetails')),
		fallback: <FallBack />,

	},
	{
		path: 'companies',
		name: 'Companies',
		Component: lazy(() => import('pages/NewCompanies')),
		fallback: <FallBack />,
		childs: [
			{ path: 'add-company', name: 'Add Company' },
			{ path: 'view-company/:postId/:id', name: 'view Company' }
		]
	},
	{
		path: 'companies/view-company/:id',
		name: 'Companies',
		Component: lazy(() => import('pages/Companies/CompanyUser')),
		fallback: <FallBack />
	},
	{
		path: 'companies/edit-company/:postId/:id',
		name: 'Edit Company',
		Component: lazy(() => import('pages/Companies/editCompany')),
		fallback: <FallBack />
	},
	{
		path: 'companies/add-company',
		name: 'Companies',
		Component: lazy(() => import('pages/Companies/addCompany')),
		fallback: <FallBack />
	},
	{
		path: 'companies/view-company/:postId/:id',
		name: 'Companies',
		Component: lazy(() => import('pages/Companies/viewCompany')),
		fallback: <FallBack />
	},

	{
		path: 'profile',
		name: 'Profile',
		Component: lazy(() => import('pages/profile')),
		fallback: <FallBack />
	},
	{
		path: 'transactions',
		name: 'Transactions',
		Component: lazy(() => import('pages/transactions')),
		fallback: <FallBack />
	},
	{
		path: 'upcommingtransactions/:category',
		name: 'TransactionsDetails',
		Component: lazy(() => import('pages/transactions')),
		fallback: <FallBack />
	},
	{
		path: 'transaction-details/:id',
		name: 'TransactionsDetails',
		Component: lazy(() => import('pages/transactions/transactionInvoiceDetails')),
		fallback: <FallBack />
	},
	{
		path: 'print-invoice/transaction-details/:id',
		name: 'TransactionsDetails',
		Component: lazy(() => import('pages/transactions/transactionInvoiceDetails')),
		fallback: <FallBack />
	},
	{
		path: 'financing-requests',
		name: 'financing-requests',
		Component: lazy(() => import('pages/finRequests')),
		fallback: <FallBack />
	},
	{
		path: ':id/approval-financing-requests',
		name: 'Approve Financing Requests',
		Component: lazy(() => import('pages/finRequests/approval')),
		fallback: <FallBack />
	},
	{
		path: 'fin-req-details/:id',
		name: 'Financing Requests Details',
		Component: lazy(() => import('pages/finRequests/finReqDetails')),
		fallback: <FallBack />
	},
	{
		path: 'print-invoice/fin-req/:id',
		name: 'Financing Requests Details',
		Component: lazy(() => import('pages/finRequests/finReqDetails')),
		fallback: <FallBack />
	},
	{
		path: 'programs',
		name: 'programs',
		Component: lazy(() => import('pages/programs')),
		fallback: <FallBack />,
		childs: [
			{ path: 'add-program', name: 'Add Program' },
			{ path: 'view-program/:postId/:id', name: 'view Program' },
			{ path: 'managing-sellers/:id', name: 'managing sellers' }
		]
	},
	{
		path: 'programs/add-program',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/addProgram')),
		fallback: <FallBack />
	},
	{
		path: 'programs/edit-program/:id/managing-sellers',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/manageingSellers')),
		fallback: <FallBack />
	},
	{
		path: 'programs/view-program-request/:postId/:id',
		name: 'Programs',
		Component: lazy(() => import('../pages/programs/viewProgramRequestChanges')),
		fallback: <FallBack />
	},
	{
		path: 'programs/view-program/:postId/:id',
		name: 'Programs',
		Component: lazy(() => import('../pages/programs/viewProgram')),
		fallback: <FallBack />
	},
	{
		path: 'programs/edit-program/:postId/:id',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/editProgram')),
		fallback: <FallBack />
	},
	{
		path: 'programs/edit-program/:id/managing-sellers/map-seller',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/mapSeller')),
		fallback: <FallBack />
	},
	{
		path: 'programs/edit-program/:name/:id/managing-sellers/map-seller',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/mapSeller')),
		fallback: <FallBack />
	},
	{
		path: 'programs/edit-program/:id/managing-sellers/edit-seller/:sellerId',
		name: 'Programs',
		Component: lazy(() => import('pages/programs/mapSeller')),
		fallback: <FallBack />
	},
	{
		path: 'bank-accounts',
		name: 'Bank Accounts',
		Component: lazy(() => import('pages/main-settings/bankAccounts')),
		fallback: <FallBack />,
		childs: [{ path: 'add-bank-account', name: 'Add Bank Account' }]
	},
	{
		path: 'admins-general-settings',
		name: 'Admins General Settings',
		Component: lazy(() => import('pages/main-settings/adminGeneralSettings')),
		fallback: <FallBack />
	},

	{
		path: 'bank-accounts/add-bank-account',
		name: 'Add Bank Account',
		Component: lazy(() => import('pages/main-settings/bankAccounts/addBankAccount')),
		fallback: <FallBack />
	},
	{
		path: 'bank-accounts/:id',
		name: 'Permissions',
		Component: lazy(() => import('pages/main-settings/bankAccounts/addBankAccount')),
		fallback: <FallBack />
	},
	{
		path: 'users',
		name: 'Users',
		Component: lazy(() => import('pages/main-settings/users')),
		fallback: <FallBack />,
		childs: [
			{ path: 'add-User', name: 'Add User' },
			{ path: 'edit-User', name: 'Edit User' },
			{ path: 'add-user-company', name: 'Add User Company' }
		]
	},
	{
		path: 'users/add-user',
		name: 'Users',
		Component: lazy(() => import('pages/main-settings/users/userForm')),
		fallback: <FallBack />
	},
	{
		path: 'users/add-comapny-user',
		name: 'Users',
		Component: lazy(() => import('pages/main-settings/users/companyUserform')),
		fallback: <FallBack />
	},
	{
		path: 'users/edit-company-user/:postId/:id',
		name: 'Users',
		Component: lazy(() => import('pages/main-settings/users/companyUserform')),
		fallback: <FallBack />
	},
	{
		path: 'users/edit/:postId/:id',
		name: 'Users',
		Component: lazy(() => import('pages/main-settings/users/userForm')),
		fallback: <FallBack />
	},
	{
		path: 'permissions',
		name: 'Roles & Permissions',
		Component: lazy(() => import('pages/main-settings/permissions')),
		fallback: <FallBack />,
		childs: [
			{ path: 'add-permission', name: 'Add permission' },
			{ path: 'Edit-permission', name: 'Edit permission' }
		]
	},
	{
		path: 'permissions/add-permission',
		name: 'Permissions',
		Component: lazy(() => import('pages/main-settings/permissions/addPermission')),
		fallback: <FallBack />
	},
	{
		path: 'permissions/:postId/:id',
		name: 'Permissions',
		Component: lazy(() => import('pages/main-settings/permissions/editPermission')),
		fallback: <FallBack />
	},
	{
		path: 'lookups',
		name: 'Lookups',
		Component: lazy(() => import('pages/main-settings/lookups')),
		fallback: <FallBack />,
		childs: [
			{ path: 'add-industry', name: 'Add Industry' },
			{ path: 'add-legal-structure', name: 'Add Legal Structure' },
			{ path: 'add-company-size', name: 'Add company size' }
		]
	},
	{
		path: 'lookups/add-industry',
		name: 'Add Industyy',
		Component: lazy(() => import('pages/main-settings/lookups/industry/add-industry')),
		fallback: <FallBack />
	},
	{
		path: 'lookups/add-legal-structure',
		name: 'Add Legal Structure',
		Component: lazy(() => import('pages/main-settings/lookups/legalStructure/addLegal')),
		fallback: <FallBack />
	},
	{
		path: 'lookups/add-company-size',
		name: 'Add Legal Structure',
		Component: lazy(() => import('pages/main-settings/lookups/companySize/addCompanySize')),
		fallback: <FallBack />
	},
	{
		path: 'notifications',
		name: 'notifications',
		Component: lazy(() => import('pages/notifications')),
		fallback: <FallBack />
	}
];

const PortalRoutes = () => {
	const { isAuthenticated, verified } = useAuth();
	return (
		<Routes>
			<Route
				exact
				path='/login'
				element={!isAuthenticated || !verified ? <LoginPage /> : <Navigate to='/dashboard' />}
			/>
			<Route path='/unauthorized/:action' element={<UnAuthorized />} />
			<Route exact path='/unauthorized' element={<UnAuthorized />} />
			<Route
				path='/'
				element={isAuthenticated && verified ? <Navigate to='/dashboard' replace /> : <Navigate to='/login' replace />}
			/>
			<Route path='/' element={isAuthenticated && verified ? <MainLayout /> : <Navigate to='/login' />}>
				{portalRoutes.map(({ path, name, Component, fallback }) => (
					<Fragment key={name}>
						<Route
							path={path}
							element={
								<Suspense fallback={fallback ? fallback : null}>
									<Component />
								</Suspense>
							}
						/>
					</Fragment>
				))}
			</Route>
		</Routes>
	);
};

export default PortalRoutes;
